import React from "react";
import Page from "../models/Page";
import { useOnChangeWatcher } from "../models/useOnChangeWatcher";
import { PagePrintInfo } from "../models/PagePrintInfo";
import RoomView from "./RoomView";
import { RDiv } from "../components/renderPrimitives/RDiv";

export default function RoomsView(props: { mainPage: Page; print?: PagePrintInfo }) {
  const { mainPage, print } = props;

  const floor = mainPage.parentFloor;
  useOnChangeWatcher(floor);

  if (floor?.className != "Floor") {
    return null;
  }

  const children: any = [];

  floor.rooms.forEach((room) => {
    if (room.roomtoFloorDrawingTransform && !room.isFloorGeneralRoom) {
      //
      // wenn der Raum noch nicht plaziert ist
      // nichts darstellen

      children.push(<RoomView key={room.id} room={room} mainPage={mainPage} print={print} />);
    }
  });

  return (
    <RDiv
      id="rooms"
      style={{
        position: "absolute",
        left: "0px",
        top: "0px",
        width: "100%",
        height: "100%",
        pointerEvents: "none",
      }}
    >
      {children}
    </RDiv>
  );
}
